import React from 'react';

interface FilterActionsProps {
  children: React.ReactNode;
}

export function FilterActions({ children }: FilterActionsProps) {
  return <div className='flex h-full flex-wrap items-end justify-end gap-2'>{children}</div>;
}

export default FilterActions;
